(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_5509e39"] && !Shopify.designMode) return;
  try {
    class WmHeroProduct extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('[data-wm-card]');
      this.panel = this.querySelector('[data-wm-panel]');
      this.angleButton = this.querySelector('[data-wm-angle]');
      this.variantInput = this.querySelector('[data-wm-variant-id]');
      this.price = this.querySelector('[data-wm-price]');
      this.cta = this.querySelector('[data-wm-cta]');
      this.variants = this.readVariants();
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion = this.motionQuery.matches;
      this.pointerTarget = { x: 0, y: 0 };
      this.pointerCurrent = { x: 0, y: 0 };
      this.pointerFrame = 0;
      this.currency = document.documentElement.lang || 'en';
      this.reveal();
      this.bindAngle();
      this.bindOptions();
      this.bindPointerDepth();
      this.onMotionPreference = (event) => {
        this.reducedMotion = event.matches;
        if (event.matches) this.resetPointerDepth();
      };
      this.motionQuery.addEventListener('change', this.onMotionPreference);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.motionQuery?.removeEventListener('change', this.onMotionPreference);
      cancelAnimationFrame(this.pointerFrame);
    }

    readVariants() {
      const node = this.querySelector('[data-wm-variants]');
      if (!node) return [];
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return [];
      }
    }

    reveal() {
      if (this.reducedMotion || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }
      this.classList.add('is-motion-ready');
      this.observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        this.classList.add('is-visible');
        this.observer.disconnect();
      }, { threshold: 0.16 });
      this.observer.observe(this);
    }

    bindAngle() {
      if (!this.angleButton || !this.card) return;
      this.angleButton.addEventListener('click', () => {
        const swap = () => {
          const active = this.card.classList.toggle('is-angle-active');
          this.angleButton.setAttribute('aria-pressed', String(active));
        };
        if (!this.reducedMotion && document.startViewTransition) {
          document.startViewTransition(swap);
        } else {
          swap();
        }
      });
    }

    bindOptions() {
      this.querySelectorAll('[data-wm-option] input').forEach((input) => {
        input.addEventListener('change', () => this.updateVariant());
      });
    }

    updateVariant() {
      const selected = Array.from(this.querySelectorAll('[data-wm-option]'))
        .map((group) => group.querySelector('input:checked')?.value);
      const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        this.setAvailability(false);
        return;
      }
      this.variantInput.value = variant.id;
      this.setAvailability(variant.available);
      const priceMarkup = `${variant.compare_at_price > variant.price ? `<s>${this.formatMoney(variant.compare_at_price)}</s>` : ''}<span>${this.formatMoney(variant.price)}</span>`;
      if (document.startViewTransition && !this.reducedMotion) {
        document.startViewTransition(() => { this.price.innerHTML = priceMarkup; });
      } else {
        this.price.innerHTML = priceMarkup;
      }
    }

    setAvailability(available) {
      if (!this.cta) return;
      this.cta.disabled = !available;
      const label = this.cta.querySelector('[data-wm-cta-label]');
      if (!label) return;
      label.textContent = available ? label.dataset.available : label.dataset.soldOut;
    }

    formatMoney(cents) {
      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat(this.currency, { style: 'currency', currency }).format(cents / 100);
    }

    bindPointerDepth() {
      if (!this.card || !this.panel || this.reducedMotion || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      this.card.addEventListener('pointermove', (event) => {
        const rect = this.card.getBoundingClientRect();
        this.pointerTarget.x = (event.clientX - rect.left) / rect.width - .5;
        this.pointerTarget.y = (event.clientY - rect.top) / rect.height - .5;
        if (!this.pointerFrame) this.animatePointerDepth();
      });
      this.card.addEventListener('pointerleave', () => {
        this.pointerTarget.x = 0;
        this.pointerTarget.y = 0;
        if (!this.pointerFrame) this.animatePointerDepth();
      });
    }

    animatePointerDepth() {
      if (this.reducedMotion) {
        this.resetPointerDepth();
        return;
      }
      const damping = .14;
      this.pointerCurrent.x += (this.pointerTarget.x - this.pointerCurrent.x) * damping;
      this.pointerCurrent.y += (this.pointerTarget.y - this.pointerCurrent.y) * damping;
      const x = this.pointerCurrent.x;
      const y = this.pointerCurrent.y;
      this.card.style.transform = `perspective(1400px) rotateX(${-y * 1.35}deg) rotateY(${x * 1.35}deg)`;
      this.panel.style.setProperty('--wm-panel-x', `${x * -8}px`);
      this.panel.style.setProperty('--wm-panel-y', `${y * -6}px`);
      const moving = Math.abs(this.pointerTarget.x - x) > .001 || Math.abs(this.pointerTarget.y - y) > .001;
      if (moving) {
        this.pointerFrame = requestAnimationFrame(() => this.animatePointerDepth());
      } else {
        this.pointerFrame = 0;
        if (this.pointerTarget.x === 0 && this.pointerTarget.y === 0) this.resetPointerDepth();
      }
    }

    resetPointerDepth() {
      cancelAnimationFrame(this.pointerFrame);
      this.pointerFrame = 0;
      this.pointerTarget = { x: 0, y: 0 };
      this.pointerCurrent = { x: 0, y: 0 };
      if (this.card) this.card.style.transform = '';
      if (this.panel) {
        this.panel.style.removeProperty('--wm-panel-x');
        this.panel.style.removeProperty('--wm-panel-y');
      }
    }
  }

  if (!customElements.get('wm-hero-product')) {
    customElements.define('wm-hero-product', WmHeroProduct);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_a6db91e"] && !Shopify.designMode) return;
  try {
    class WmHeroCollection extends HTMLElement {
    connectedCallback() {
      this.track=this.querySelector('[data-wm-track]');
      this.slides=Array.from(this.querySelectorAll('[data-wm-slide]'));
      this.dots=Array.from(this.querySelectorAll('[data-wm-dot]'));
      this.status=this.querySelector('[data-wm-status]');
      this.index=0;
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile=window.matchMedia('(max-width: 749px)');
      this.mobileColumns=Math.max(2,Math.min(3,Number(this.dataset.mobileColumns)||2));
      this.previous=this.querySelector('[data-wm-prev]');
      this.next=this.querySelector('[data-wm-next]');
      this.onLayoutChange=()=>{this.index=Math.min(this.index,this.maxIndex());this.render();};
      this.reveal();
      if(!this.track||this.slides.length<1)return;
      this.previous?.addEventListener('click',()=>this.go(this.index-1));
      this.next?.addEventListener('click',()=>this.go(this.index+1));
      this.dots.forEach((dot)=>dot.addEventListener('click',()=>this.go(Number(dot.dataset.index))));
      this.querySelectorAll('[data-wm-angle]').forEach((button)=>button.addEventListener('click',()=>this.toggleAngle(button)));
      this.querySelectorAll('[data-wm-cart]').forEach((button)=>button.addEventListener('click',()=>this.addToCart(button)));
      this.mobile.addEventListener?.('change',this.onLayoutChange);
      this.bindSwipe();
      this.render();
    }

    disconnectedCallback(){this.observer?.disconnect();this.mobile?.removeEventListener?.('change',this.onLayoutChange);}

    reveal(){
      if(this.motion.matches||!('IntersectionObserver'in window)){this.classList.add('is-visible');return;}
      this.classList.add('is-motion-ready');
      this.observer=new IntersectionObserver((entries)=>{if(!entries[0].isIntersecting)return;this.classList.add('is-visible');this.observer.disconnect();},{threshold:.12});
      this.observer.observe(this);
    }

    go(next){
      const maximum=this.maxIndex();
      this.index=next<0?maximum:next>maximum?0:next;
      const update=()=>{
        this.render();
      };
      if(!this.motion.matches&&document.startViewTransition)document.startViewTransition(update);else update();
    }

    visibleCount(){return this.mobile.matches?Math.min(this.mobileColumns,this.slides.length):1;}

    maxIndex(){return Math.max(0,this.slides.length-this.visibleCount());}

    render(){
      const maximum=this.maxIndex();
      this.track.style.setProperty('--wm-index',String(this.index));
      this.slides.forEach((slide,index)=>slide.classList.toggle('is-active',index>=this.index&&index<this.index+this.visibleCount()));
      this.dots.forEach((dot,index)=>{dot.hidden=index>maximum;if(index===this.index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
      const disabled=maximum===0;
      if(this.previous)this.previous.disabled=disabled;
      if(this.next)this.next.disabled=disabled;
    }

    toggleAngle(button){
      const slide=button.closest('[data-wm-slide]');
      const update=()=>{const active=slide.classList.toggle('is-angle');button.setAttribute('aria-pressed',String(active));};
      if(!this.motion.matches&&document.startViewTransition)document.startViewTransition(update);else update();
    }

    bindSwipe(){
      const stage=this.querySelector('[data-wm-stage]');
      let startX=0;
      stage.addEventListener('pointerdown',(event)=>{if(event.target.closest('button,a'))return;startX=event.clientX;},{passive:true});
      stage.addEventListener('pointerup',(event)=>{if(!startX)return;const distance=startX-event.clientX;startX=0;if(Math.abs(distance)>45)this.go(this.index+(distance>0?1:-1));},{passive:true});
    }

    async addToCart(button){
      if(button.dataset.options==='true'){window.location.assign(button.dataset.productUrl);return;}
      const label=button.querySelector('[data-wm-cart-label]');
      button.disabled=true;label.textContent=button.dataset.loadingLabel;
      try{
        const root=window.Shopify?.routes?.root||'/';
        const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]})});
        if(!response.ok)throw new Error('Cart request failed');
        label.textContent=button.dataset.addedLabel;
        if(this.status)this.status.textContent=button.dataset.addedLabel;
        document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        window.setTimeout(()=>{label.textContent=button.dataset.defaultLabel;button.disabled=false;},1200);
      }catch(error){label.textContent=button.dataset.defaultLabel;button.disabled=false;if(this.status)this.status.textContent=error.message;}
    }
  }
  if(!customElements.get('wm-hero-collection'))customElements.define('wm-hero-collection',WmHeroCollection);
  } catch(e) { console.error(e); }
})();

})();
